<template>
	<section class="content">
		<div class="row">
			<div class="col-md-12">
				<div class="box box-primary">
					<div class="box-header with-border">
						<h3 class="box-title">
							<b>Empresas</b>
						</h3>
						<router-link tag="a" class="btn btn-primary pull-right" to="/administracao/empresas/nova">Nova</router-link>
					</div>
					<div class="box-body">
						<div class="row">
							<div class="col-md-12">
								<input style="width: 100%" class="form-control" placeholder="Busca: Entre com o nome da empresa" name="filtro_pesquisa" ref="filtro_pesquisa" type="text" v-model="filtros.pesquisa" @keyup.enter="getDataTable">
							</div>
						</div>
						<div class="row" style="margin-top:15px">
							<div class="col-sm-12 table-responsive">
								<table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped">
									<thead>
									<tr role="row">
										<th style="width: 8%">ID</th>
										<th style="width: 15%">Fantasia</th>
										<th style="width: 14%">CNPJ</th>
										<th style="width: 12%">Telefone</th>
										<th style="width: 12%">Email</th>
										<th style="width: 8%">Situação</th>
										<th style="width: 12%">Dt. Cadastro</th>
										<th style="width: 9%" >Ação</th>
									</tr>
									</thead>
									<tbody>
									<tr class="even" role="row" v-for="item in apiData.data" :key="item.id">
										<td>{{ item.id }}</td>
										<td>{{ item.fantasia }}</td>
										<td>{{ item.cnpj }}</td>
										<td>{{ item.tel1 }} {{ item.tel2 }} {{ item.tel3 }}</td>
										<td>{{ item.email }}</td>
										<td>{{ item.situacao }}</td>
										<td>{{ item.created_at | dataFormatada }}</td>
										<td>
											<router-link class="btn btn-warning btn-sm" tag="button" :to="'/administracao/empresas/atualizacao/'+ item.id" title="Atualizar">
												<i class="fa fa-fw fa-edit"></i>
											</router-link>
											<button v-if="item.situacao == 'ATIVA'" @click="disable(item.id)" class="btn btn-danger btn-sm" title="Bloquear">
												<i class="fa fa-fw fa-lock"></i>
											</button>
											<button v-else @click="enable(item.id)" class="btn btn-success btn-sm" title="Ativar">
												<i class="fa fa-fw fa-unlock"></i>
											</button>
										</td>
									</tr>
									</tbody>
								</table>
								<div class="row">
									<div class='col-sm-5'>
										Mostrando {{ this.apiData.from }} até {{ this.apiData.to }} de {{ this.apiData.total }} registros encontrados.
									</div>
									<div class='col-sm-7' style="text-align:right">
										<laravue-pagination :limit="5" :data="apiData" v-on:pagination-change-page="getDataTable">
											<span slot="prev-nav">&lt; Anterior</span>
											<span slot="next-nav">Próximo &gt;</span>
										</laravue-pagination>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- /.box-body -->
				</div>
				<!-- /.box -->
			</div>
			<!-- /.col-md-12 -->
		</div>
		<!-- /.row -->
	</section>
</template>
<script>
	import axios from 'axios' // Cliente para requisição http
	export default {
		data: () => ({
			filtros: {
				pesquisa: '',
			},
			apiData: {
				data: [],
			},
		}),
		mounted () {
			this.getDataTable();
			this.$nextTick(() => { this.$refs.filtro_pesquisa.focus() });
		},

		methods: {
			getDataTable (page) {
				if (typeof page === 'undefined') {
					page = 1;
				}
				this.filtros.page = page;
				let config = this.$store.getters.getHeaderAuth;
				config.params = this.filtros;
				axios.get(`${this.$store.state.serverURI}/api/empresa/getAllPaginate`, config)
					.then(response => {
						this.apiData = response.data;
					}).catch((error) => { this.$store.commit('throwException', error); });
			},

			enable(empresaId) {
				this.$swal({
					title: "Ativar Empresa?",
					text: "Confirma a ativação dessa empresa?",
					type: "question",
					showCancelButton: true,
					confirmButtonColor: "#3085d6",
					cancelButtonColor: "#d33",
					confirmButtonText: '<i class="fa fa-check"></i> Confirmar',
					cancelButtonText: '<i class="fa fa-times"></i> Cancelar',
					reverseButtons: true,
				}).then((result) => {
					if (result.value) {
						axios
							.post(
								`${this.$store.state.serverURI}/api/empresa/enable/${empresaId}`,
								{},
								this.$store.getters.getHeaderAuth
							)
							.then(response => {
								this.$swal({
									type: response.data.status == 200 ? "success" : "error",
									title:
										response.data.status == 200
											? "Tudo Certo!"
											: "Ops! Ocorreu um erro.",
									text: response.data.msg,
									showConfirmButton: false,
									timer: 1500
								});
								this.getDataTable();
							})
							.catch(error => {
								this.$store.commit("SHOW_ALERT_ERROR");
								console.log(error);
							});
					}
				})
			},

			disable(empresaId) {
				this.$swal({
					title: "Bloquear Empresa?",
					text: "Confirma a bloqueio dessa empresa?",
					type: "question",
					showCancelButton: true,
					confirmButtonColor: "#3085d6",
					cancelButtonColor: "#d33",
					confirmButtonText: '<i class="fa fa-check"></i> Confirmar',
					cancelButtonText: '<i class="fa fa-times"></i> Cancelar',
					reverseButtons: true,
				}).then((result) => {
					if (result.value) {
						axios
							.post(
								`${this.$store.state.serverURI}/api/empresa/disable/${empresaId}`,
								{},
								this.$store.getters.getHeaderAuth
							)
							.then(response => {
								this.$swal({
									type: response.data.status == 200 ? "success" : "error",
									title:
										response.data.status == 200
											? "Tudo Certo!"
											: "Ops! Ocorreu um erro.",
									text: response.data.msg,
									showConfirmButton: false,
									timer: 1500
								});
								this.getDataTable();
							})
							.catch(error => {
								this.$store.commit("SHOW_ALERT_ERROR");
								console.log(error);
							});
					}
				})
			},

		},
		watch: {
			page: function (val) {
				this.getDataTable();
			}
		},

		components: {

		}

	}
</script>
<style>
</style>



// WEBPACK FOOTER //
// index.vue?5947a7eb